<template>
    <div class="plagiarism-container">
        <div class="check-container">
            <div class="check-main">
                <div class="notice-section">
                    <div class="notice-title">
                        <h3>注意事项</h3>
                    </div>
                    <div class="notice-content">
                        <ul>
                            <li>
                                <span class="highlight"
                                    >【免费查AI】降AI充值会员可联系人工客服免费查AI一次</span
                                >
                            </li>
                            <li>
                                <span class="highlight"
                                    >【查AI次数充值】多次查询可享受充值优惠，详情查看“充值”页面
                                </span>
                            </li>
                            <li>仅支持英文、西班牙文和日文，支持文件格式：Word, PDF</li>
                            <li>上传文档英文单词数需在300-30000词之间，字数范围外无法提供报告。</li>
                            <li>
                                <span class="highlight"
                                    >文档不会被Tūrnitin收录！不会被收录！不会被收录！</span
                                >
                            </li>
                            <li>
                                本平台定时清理缓存，<span class="highlight"
                                    >文档不会被泄露！不会被泄露！不会被泄露！</span
                                >
                            </li>
                            <li>Tūrnitin重复度检测已默认排除双引号引用的原文和参考文献</li>
                            <li>
                                Tūrnitin最新版本规定，AI率1-19%被标记为*%，无任何高亮显示
                                <a
                                    href="https://guides.Tūrnitin.com/hc/en-us/articles/28457596598925-AI-writing-detection-in-the-classic-report-view#:~:text=To%20avoid%20potential%20incidence%20of,and%20no%20percentage%20is%20attributed"
                                    target="_blank"
                                    class="info-link"
                                    >[?]</a
                                >
                                ，如需付费显示，请联系客服。
                            </li>
                            <li>
                                检测结果预计在5-20分钟内产生，文件大小会影响报告产出速度，请耐心等待，有任何疑问请联系客服
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="upload-section">
                    <div class="price-tip">
                        Tūrnitin重复率+AI率检测:<span class="price">5.99</span>RMB/次
                    </div>
                    <!-- 添加剩余查重次数显示 -->
                    <div class="remaining-count-tip">
                        剩余查AI次数:
                        <span class="count">{{ plagiarismCount || 0 }}</span> 次
                    </div>
                    <div
                        class="upload-wrapper"
                        v-loading="isUploading"
                        element-loading-text="文件上传中，请稍候..."
                    >
                        <el-upload
                            class="upload"
                            drag
                            :limit="1"
                            :auto-upload="false"
                            accept=".doc,.docx,.pdf"
                            action="/api/check-duplicate"
                            :on-success="handleUploadSuccess"
                            :on-error="handleUploadError"
                            :before-upload="beforeUploadCheck"
                            :on-change="handleFileChange"
                            :on-exceed="handleExceed"
                            :on-remove="handleRemove"
                            :file-list="fileList"
                            ref="uploadRef"
                            :disabled="isUploading"
                        >
                            <el-icon class="el-icon--upload"><upload-filled /></el-icon>
                            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                            <template #tip>
                                <div class="el-upload__tip">
                                    支持 doc, docx, pdf 格式文件，且不超过10MB
                                </div>
                            </template>
                        </el-upload>
                    </div>

                    <div class="check-items">
                        <el-button
                            type="primary"
                            :disabled="!hasFile || isUploading"
                            @click="submitCheck"
                            class="check-button"
                            size="large"
                        >
                            {{ isUploading ? '上传中...' : '查AI' }}
                        </el-button>
                        <div class="check-options">
                            <div class="option-item">
                                <span class="option-label">排除参考文献</span>
                                <el-switch v-model="excludeBibliography" />
                            </div>
                            <div class="option-item">
                                <span class="option-label">排除引用内容</span>
                                <el-switch v-model="excludeQuotes" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 查重历史记录表格 -->
            <div class="history-card">
                <div class="header-content">
                    <span class="header-title">查AI历史记录</span>
                    <span class="header-hint">(刷新页面查看结果)</span>
                </div>
                <div class="privacy-notice">为保护用户隐私，请尽快下载报告，后台会不定时清理</div>
                <div class="table-wrapper">
                    <el-table :data="plagiarismHistory" :border="false" style="width: 1100px">
                        <el-table-column label="ID" width="100">
                            <template #default="scope">
                                {{ getFileName(scope.row.reportId) }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="file_path" label="文件名" style="width: 300px">
                            <template #default="scope">
                                {{ getFileName(scope.row.filePath) }}
                            </template>
                        </el-table-column>
                        <el-table-column label="状态" width="100">
                            <template #default="scope">
                                <el-tag :type="getStatusType(scope.row.status)">
                                    {{ getStatusText(scope.row.status) }}
                                </el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="查重率" width="100">
                            <template #default="scope">
                                <span
                                    v-if="
                                        scope.row.similarityPercent !== null &&
                                        scope.row.similarityPercent !== undefined
                                    "
                                    >{{ scope.row.similarityPercent }}
                                </span>
                                <span v-else>—</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="AI率" width="100">
                            <template #default="scope">
                                <span
                                    v-if="
                                        scope.row.aiPercent !== null &&
                                        scope.row.aiPercent !== undefined
                                    "
                                    >{{ scope.row.aiPercent }}
                                </span>
                                <span v-else>—</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="查重报告" width="100">
                            <template #default="scope">
                                <a
                                    v-if="scope.row.plagiarismReportUrl"
                                    :href="scope.row.plagiarismReportUrl"
                                    target="_blank"
                                    class="details-link"
                                >
                                    查看
                                </a>
                                <span v-else>—</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="AI报告" width="100">
                            <template #default="scope">
                                <a
                                    v-if="scope.row.aiReportUrl"
                                    :href="scope.row.aiReportUrl"
                                    target="_blank"
                                    class="details-link"
                                >
                                    查看
                                </a>
                                <span v-else>—</span>
                            </template>
                        </el-table-column>

                        <el-table-column label="源文件" width="100">
                            <template #default="scope">
                                <a
                                    v-if="scope.row.submittedFileUrl"
                                    :href="scope.row.submittedFileUrl"
                                    target="_blank"
                                    class="details-link"
                                >
                                    查看
                                </a>
                                <span v-else>—</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="createAt"
                            label="创建时间"
                            :formatter="dateTimeFormatter"
                            width="180"
                        />
                    </el-table>
                </div>

                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[5, 10, 20]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalCount"
                />
            </div>
        </div>
        <div class="goods-remind">
            <el-dialog
                v-model="goodsReminder"
                title="如未弹出支付窗口，请按以下步骤启用弹窗："
                width="500"
                draggable
                destroy-on-close
            >
                <p>1. 在浏览器地址栏的右侧或左侧寻找"弹窗已被阻止"的提示信息。</p>
                <p>2. 点击提示，并选择"允许弹窗"。</p>
                <p>3. 刷新页面以确保设置生效。</p>
                <template #footer>
                    <div class="dialog-footer">
                        <el-button type="primary" @click="goodsReminder = false"> 确认 </el-button>
                    </div>
                </template>
            </el-dialog>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { UploadFilled } from '@element-plus/icons-vue'
import { ElMessage, ElLoading, ElMessageBox } from 'element-plus'
import { apiService } from '@/api/Api.js'
import { alertService } from '@/utils/alertService.js'
import { removeToken } from '@/stores/authStore'
import { formatTimeToMinuteUTC } from '@/utils/formatDateTime.js'
import { getFileName, getStatusText, getStatusType } from '@/utils/plagiarismUtils.js'

// 定义组件名称
defineOptions({
    name: 'PlagiarismCheck'
})

const uploadRef = ref()
const hasFile = ref(false)
const fileList = ref([])
const isUploading = ref(false)
const excludeBibliography = ref(true)
const excludeQuotes = ref(true)
const goodsReminder = ref(false)

const plagiarismCount = ref(0)
// 添加用户信息状态

// 获取用户信息
const getPlagiarismCount = async () => {
    try {
        const response = await apiService.getPlagiarismCount()
        console.log('response:', response)
        plagiarismCount.value = response.data.plagiarismCount
        console.log('plagiarismCount:', plagiarismCount.value)
    } catch (error) {
        if (error.response?.data?.code === 401) {
            removeToken()
            alertService.showError('用户未登录')
        } else {
            console.error('获取用户信息失败:', error)
        }
    }
}

const handleRemove = (file) => {
    uploadRef.value.handleRemove(file)
    hasFile.value = false
    fileList.value = []
    isUploading.value = false
}

// 处理超出文件数量限制
const handleExceed = (files) => {
    if (uploadRef.value) {
        // 显示确认对话框
        ElMessageBox.confirm(
            '您已经选择了一个文件，上传新文件将覆盖之前的文件，是否继续？',
            '覆盖确认',
            {
                confirmButtonText: '确认覆盖',
                cancelButtonText: '取消',
                type: 'warning'
            }
        )
            .then(() => {
                // 用户确认覆盖，清除旧文件，添加新文件
                uploadRef.value.clearFiles()
                const file = files[0]
                console.log('handleExceed file:', file)
                // // 生成文件名：使用时间戳_原始文件名作为uid
                // const timestamp = Date.now()
                // const safeFileName = file.name.replace(/[^\w.-]/g, '_') // 移除特殊字符
                // file.uid = `${timestamp}_${safeFileName}`

                uploadRef.value.handleStart(file)
                hasFile.value = true
                // fileList.value = [file]
            })
            .catch(() => {
                // 用户取消覆盖，不做任何操作
                ElMessage.info('已取消上传新文件')
            })
    }
}

// 处理文件变更
const handleFileChange = (file) => {
    console.log('handleFileChange file:', file)
    hasFile.value = file && file.status === 'ready'
    if (hasFile.value) {
        fileList.value = [file]
    } else {
        fileList.value = []
    }
}

const submitCheck = async () => {
    if (!fileList.value[0]) {
        ElMessage.warning('请选择要检测的文件')
        return
    }

    isUploading.value = true
    const loadingInstance = ElLoading.service({
        fullscreen: true,
        text: '正在上传文件，请稍候...',
        background: 'rgba(0, 0, 0, 0.7)'
    })

    try {
        const file = fileList.value[0].raw

        // 读取文件为Base64
        const base64Content = await new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.onload = () => {
                // reader.result是一个形如"data:application/pdf;base64,XXXX"的字符串
                // 我们需要去掉前缀，只保留Base64部分
                const base64String = reader.result.split(',')[1]
                resolve(base64String)
            }
            reader.onerror = reject
            reader.readAsDataURL(file)
        })

        // 构建请求数据，使用开关的值
        const plagiarismFileInfo = {
            fileContent: base64Content, // 使用修改后的字段名
            fileName: file.name,
            fileType: file.type,
            fileSize: file.size,
            excludeBibliography: excludeBibliography.value,
            excludeQuotes: excludeQuotes.value
        }

        // await doRecharge(productId, rechargeAmount, subject, plagiarismFileInfo)
        await submitPlagiarismFile(plagiarismFileInfo)
    } catch (error) {
        console.error('提交检测失败:', error)
        if (error.response?.data?.code === 401) {
            removeToken()
            alertService.showError('用户未登录')
            // router.push('/login')
        } else {
            alertService.showError(error.response?.data?.message || '提交失败请重试')
        }
    } finally {
        loadingInstance.close()
        isUploading.value = false
    }
}

const handleUploadError = () => {
    // 这个不会被使用，因为我们手动处理上传
    ElMessage.error('文件上传失败，请重试')
}


// 直接提交查重文件
const submitPlagiarismFile = async (plagiarismFileInfo) => {
    const formData = new FormData()
    formData.append('fileInfo', JSON.stringify(plagiarismFileInfo))
    try {
        const response = await apiService.submitPlagiarismFile(formData)
        console.log('submitPlagiarismFile response:', response)
        alertService.showSuccess('提交成功')
    } catch (error) {
        console.error('提交查重文件失败:', error)
        alertService.showError(error.response?.data?.message || '发生未知错误！')
    }
}

// 查重历史相关代码
const plagiarismHistory = ref([])
const totalCount = ref(0)
const currentPage = ref(1)
const pageSize = ref(5)

// 获取查重历史记录
const fetchPlagiarismHistory = async () => {
    try {
        const requestParams = {
            pageInfo: {
                pageSize: pageSize.value,
                page: currentPage.value
            },
            orderBy: {
                field: 'create_at',
                desc: true
            }
        }

        const response = await apiService.listPlagiarismResult(requestParams)
        console.log('response:', response)
        plagiarismHistory.value = response.data.plagiarisms
        totalCount.value = Number(response.data.totalCount)
    } catch (error) {
        if (error.response?.data?.code === 401) {
            removeToken()
            alertService.showError('用户未登录')
            // router.push('/login')
        } else {
            alertService.showError(error.response?.data?.message || '发生未知错误！')
        }
    }
}

// 分页处理函数
const handleCurrentChange = (newPage) => {
    currentPage.value = newPage
    fetchPlagiarismHistory()
}

const handleSizeChange = (newSize) => {
    pageSize.value = newSize
    currentPage.value = 1 // 重置到第一页
    fetchPlagiarismHistory()
}

const dateTimeFormatter = (_row, _column, cellValue) => {
    return formatTimeToMinuteUTC(cellValue)
}

// 组件挂载时获取查重历史
onMounted(() => {
    fetchPlagiarismHistory()
    getPlagiarismCount() // 在组件挂载时获取用户信息
})
</script>

<style scoped>
.plagiarism-container {
    display: flex;
    width: 100%;
    margin: 0 auto;
    min-width: 1100px;
    padding: 0 20px;
    .check-container {
        display: flex;
        gap: 20px;
        flex-direction: column;
        align-items: center;
        margin: 0 auto;

        .check-main {
            display: flex;
            flex-direction: row;
            width: 1100px;
            margin-top: 50px;
            .notice-section {
                padding: 20px;
                background-color: #f5f7fa;
                border-radius: 4px;
                width: 570px;
                height: 450px; /* 固定高度 */
                display: flex;
                flex-direction: column;
                margin-right: 20px;
                .notice-title {
                    h3 {
                        margin-bottom: 16px;
                        color: #303133;
                    }
                }
                .notice-content {
                    ul {
                        padding-left: 20px;
                    }
                    li {
                        margin-bottom: 12px;
                        color: #606266;
                    }
                    .highlight {
                        color: #ff4d4f;
                        font-weight: bold;
                    }
                }
                .info-link {
                    color: #409eff;
                    text-decoration: none;
                }

                .info-link:hover {
                    text-decoration: underline;
                }
            }

            .upload-section {
                display: flex;
                width: 600px;
                flex-direction: column;
                height: 440px; /* 固定高度，与notice一致 */
                .price-tip {
                    text-align: center;
                    margin-bottom: 15px;
                    color: #606266;
                    font-size: 16px;
                    padding: 8px 20px;
                    background: linear-gradient(45deg, #fff1f1, #fff9f9);
                    border-radius: 20px;
                    box-shadow: 0 2px 12px rgba(255, 107, 107, 0.1);
                    display: inline-block;
                    position: relative;
                    left: 50%;
                    transform: translateX(-50%);
                    border: 1px solid #ffe4e4;
                    .price {
                        color: #ff6b6b;
                        font-size: 24px;
                        font-weight: bold;
                        margin: 0 4px;
                        text-shadow: 1px 1px 2px rgba(255, 107, 107, 0.2);
                        font-family: 'Arial', sans-serif;
                    }
                }
                .remaining-count-tip {
                    text-align: center;
                    margin-bottom: 15px;
                    color: #606266;
                    font-size: 16px;
                    padding: 8px 20px;
                    background: linear-gradient(45deg, #fff1f1, #fff9f9);
                    border-radius: 20px;
                    box-shadow: 0 2px 12px rgba(255, 107, 107, 0.1);
                    display: inline-block;
                    position: relative;
                    left: 50%;
                    transform: translateX(-50%);
                    border: 1px solid #ffe4e4;
                    .count {
                        color: #ff6b6b;
                        font-size: 24px;
                        font-weight: bold;
                        margin: 0 4px;
                        text-shadow: 1px 1px 2px rgba(255, 107, 107, 0.2);
                        font-family: 'Arial', sans-serif;
                    }
                }
                .upload-wrapper {
                    flex: 1;
                    position: relative;
                    .upload {
                        .el-upload--text {
                            background-color: #f5f7fa;
                        }
                        width: 100%;
                    }
                }

                .check-items {
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    align-items: center;
                    .check-options {
                        display: flex;
                        justify-content: center;
                        flex-direction: column;
                        margin: 15px 0;
                        gap: 20px;
                        .option-item {
                            display: flex;
                            align-items: center;
                            gap: 8px;
                            .option-label {
                                font-size: 14px;
                                color: #606266;
                            }
                        }
                    }
                    .check-button {
                        margin-top: 20px;
                        width: 180px;
                        height: 45px;
                        font-size: 16px;
                        background: linear-gradient(45deg, #409eff, #67c23a);
                        border: none;
                        position: relative;
                        left: 50%;
                        transform: translateX(-50%);
                        transition: all 0.3s ease;
                    }
                    .check-button:hover {
                        background: linear-gradient(45deg, #66b1ff, #85ce61);
                        transform: translateX(-50%) translateY(-2px);
                        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
                    }
                    .check-button:disabled {
                        background: #909399;
                        cursor: not-allowed;
                        transform: translateX(-50%);
                        box-shadow: none;
                    }
                }
            }
        }

        /* 添加历史记录表格样式 */
        .history-card {
            margin-top: 30px;
            border: 1px solid #002f5a;
            padding: 16px;
            background-color: #fff;
            border-radius: 8px;
            box-shadow:
                inset 3px 3px 5px rgba(0, 0, 0, 0.2),
                inset -3px -3px 5px rgba(255, 255, 255, 0.8);
        }

        .header-content {
            margin-bottom: 10px;
            text-align: center;
            display: flex;
            justify-content: center;
            align-items: center;
            .header-title {
                font-size: 20px;
                font-weight: bold;
                margin-right: 10px;
            }
            .header-hint {
                font-size: 14px;
                color: #909399;
            }
        }

        .privacy-notice {
            color: #ff6b6b;
            font-size: 14px;
            margin-bottom: 20px;
            text-align: center;
            font-weight: 500;
        }

        .table-wrapper {
            overflow-x: auto;
            -webkit-overflow-scrolling: touch;
            margin-bottom: 20px;
        }

        .details-link {
            color: #1e90ff;
            text-decoration: underline;
        }

        .details-link:hover {
            color: #104e8b;
            cursor: pointer;
        }

        .el-pagination {
            margin-top: 20px;
            text-align: center;
        }
    }
}

:deep(.el-upload-dragger) {
    width: 100%;
    height: 180px; /* 调整上传区域高度 */
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #f5f7fa; /* 添加这行来改变背景色 */
    border: 2px dashed #c0c4cc; /* 修改虚线的粗细和颜色 */
}
:deep(.el-upload-list__item) {
    font-size: 16px; /* 修改文件名大小 */
    padding: 8px 0; /* 增加一些内边距 */
}
:deep(.el-upload-list__item:hover) {
    background-color: transparent; /* 移除悬停背景色 */
}

:deep(.el-upload-list__item-name) {
    color: #606266; /* 文件名颜色 */
    margin-left: 8px; /* 文件名左侧间距 */
    font-size: 18px;
}

:deep(.el-upload-list__item .el-icon) {
    font-size: 20px; /* 图标大小也相应调整 */
}

:deep(.el-loading-mask) {
    background-color: rgba(255, 255, 255, 0.9);
    border-radius: 4px;
}

:deep(.el-loading-text) {
    color: #409eff;
    font-size: 14px;
    margin-top: 8px;
}
</style>
